import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../context/LanguageContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, Ruler, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
    const { t } = useI18n();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#0b0f17] text-slate-100 cad-grid p-6">
            <div className="w-full max-w-sm fade-in-up bg-[#111827]/90 backdrop-blur-md border border-[#1e293b] rounded-2xl p-8 shadow-2xl">
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center"><Ruler className="w-5 h-5 text-white" /></div>
                    <div className="font-mono font-bold text-lg">BLIND<span className="text-blue-500">CAD</span></div>
                </div>
                {sent ? (
                    <div data-testid="forgot-sent" className="text-center">
                        <MailCheck className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
                        <h2 className="text-xl font-mono font-bold">{t("auth_forgot_title")}</h2>
                        <p className="text-slate-400 text-sm mt-3">{t("auth_forgot_sent")}</p>
                        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-blue-400 hover:text-blue-300 text-sm"><ArrowLeft className="w-4 h-4" /> {t("auth_back_login")}</Link>
                    </div>
                ) : (
                    <>
                        <h2 className="text-2xl font-mono font-bold">{t("auth_forgot_title")}</h2>
                        <p className="text-slate-400 text-sm mt-1">{t("auth_forgot_sub")}</p>
                        <form onSubmit={submit} className="mt-6 space-y-4">
                            <div>
                                <Label htmlFor="email" className="text-slate-300">{t("auth_email")}</Label>
                                <Input id="email" data-testid="forgot-email-input" type="email" value={email}
                                    onChange={(e) => setEmail(e.target.value)} required
                                    className="mt-1.5 bg-[#0b0f17] border-[#1e293b] text-slate-100" placeholder="name@company.com" />
                            </div>
                            {error && <div data-testid="forgot-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-md px-3 py-2">{error}</div>}
                            <Button data-testid="forgot-submit-button" type="submit" disabled={loading}
                                className="w-full bg-blue-600 hover:bg-blue-500 text-white">
                                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : t("auth_forgot_btn")}
                            </Button>
                        </form>
                        <p className="mt-6 text-center">
                            <Link to="/login" className="inline-flex items-center gap-1 text-blue-400 hover:text-blue-300 text-sm"><ArrowLeft className="w-4 h-4" /> {t("auth_back_login")}</Link>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}
